export class ApiError extends Error {
  constructor(public status: number, public body: unknown) { super(`api ${status}`); }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: { 'content-type': 'application/json', ...(init.headers ?? {}) },
    ...init,
  });
  if (!res.ok) throw new ApiError(res.status, await res.text().catch(() => ''));
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}
